// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_WH4","cls2":"LoswpTabsHero-cls2_Dsm LoswpTabsHero-cls1_WH4"};